<ngx-loading-bar [includeSpinner]="false" color="white"></ngx-loading-bar>
<div id="pcoded" class="pcoded"
     [ngClass]="animateSidebar"
     [attr.nav-type]="navType"
     [attr.theme-layout]="themeLayout"
     [attr.vertical-placement]="verticalPlacement"
     [attr.vertical-layout]="verticalLayout"
     [attr.pcoded-device-type]="pcodedDeviceType"
     [attr.vertical-nav-type]="verticalNavType"
     [attr.vertical-effect]="verticalEffect"
     [attr.vnavigation-view]="vnavigationView"
     [attr.fream-type]="freamType"
     [attr.sidebar-img]="sidebarImg"
     [attr.sidebar-img-type]="sidebarImgType"
     [attr.layout-type]="layoutType"
     (window:resize)="onResize($event)"
>
  <div class="pcoded-overlay-box"></div>
  <div class="pcoded-container navbar-wrapper">
    <nav class="navbar header-navbar pcoded-header" [attr.header-theme]="headerTheme" [attr.pcoded-header-position]="pcodedHeaderPosition">
      <div class="navbar-wrapper">
        <div class="navbar-logo">
          <a *ngIf="!auth.isDealerTabletUser()" class="mobile-menu ripple light" id="mobile-collapse" href="javascript:" (click)="toggleOpened($event)" [exclude]="'#main_navbar'" (clickOutside)="onClickedOutsideSidebar($event)">
            <i class="feather" [ngClass]="toggleIcon"></i>
          </a>
          <a [routerLink]="auth.isDealerTabletUser() ? ['quote','overview'] : ['dashboard']" class="ripple light">
            <img class="img-fluid w-50" src="assets/images/urbansofa_logo_white.png" alt="Able Pro 7" />
          </a>
          <a *ngIf="!auth.isDealerTabletUser()" href="javascript:" class="mobile-options ripple light" (click)="toggleHeaderNavRight()">
            <i class="feather icon-more-horizontal"></i>
          </a>
          <div class="navbar-container tablet-options">
            <ul *ngIf="auth.isDealerTabletUser()" class="nav-right nav-on">
              <li (clickOutside)="notificationOutsideClick('profile')" class="user-profile header-notification ripple light" (click)="toggleProfileNotification()">
                <a href="javascript:">
                  <span>{{auth.getFullName()}}</span>
                  <i class="feather icon-chevron-down"></i>
                </a>
                <ul [@notificationBottom]="profileNotification" class="show-notification profile-notification tablet-notification" [ngClass]="profileNotificationClass">
                  <!--<li class="ripple">-->
                  <!--<a href="javascript:">-->
                  <!--<i class="feather icon-settings"></i> Settings-->
                  <!--</a>-->
                  <!--</li>-->
                  <!--<li class="ripple">-->
                  <!--<a [routerLink]="['/user/profile/']">-->
                  <!--<i class="feather icon-user"></i> Profile-->
                  <!--</a>-->
                  <!--</li>-->
                  <!--<li class="ripple">-->
                  <!--<a href="javascript:">-->
                  <!--<i class="feather icon-mail"></i> My Messages-->
                  <!--</a>-->
                  <!--</li>-->
                  <!--<li class="ripple">-->
                  <!--<a [routerLink]="['/auth/lock-screen/']" target="_blank">-->
                  <!--<i class="feather icon-lock"></i> Lock Screen-->
                  <!--</a>-->
                  <!--</li>-->
                  <li class="ripple" style="padding: 0">
                    <a (click)="lock()" style="display:block;width:100%;height:100%;padding: 15px;">
                      <i class="feather icon-lock"></i> {{'admin.lock'|translate}}
                    </a>
                  </li>
                  <li class="ripple" style="padding: 0">
                    <a (click)="logout()" style="display:block;width:100%;height:100%;padding: 15px;">
                      <i class="feather icon-log-out"></i> {{'admin.logout'|translate}}
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div class="navbar-container container-fluid">
          <ul class="nav-left">
            <li class="ripple light">
              <div class="sidebar_toggle"><a href="javascript:"><i class="icon-menu"></i></a></div>
            </li>
          </ul>
          <ul *ngIf="!auth.isDealerTabletUser()" [@mobileHeaderNavRight]="navRight" [ngClass]="navRight" class="nav-right">
            <li *ngIf="auth.isBackOffice()">
                <a (click)="connectionConfirmModal()" class="p-0">
                  <span class="text-white">{{'admin.exact.connection_status'|translate}}</span>
                  <ng-container *ngIf="connectedToExact else exactDisconnected">
                    <i *ngIf="exactExpireDays > 0" class="fa fa-check exact-status bg-success"></i>
                    <i *ngIf="exactExpireDays <= 0" class="fa fa-exclamation px-2 exact-status bg-warning"></i>
                  </ng-container>
                  <ng-template #exactDisconnected><i class="fa fa-close exact-status bg-danger"></i></ng-template>
                </a>
            </li>
            <li *ngIf="auth.isBackOffice() && connectedToExact">
                <a (click)="connectionConfirmModal()" class="p-0">
                  <span class="text-white" *ngIf="exactExpireDays > 0 else reloginRecommended">
                    {{'admin.exact.login_again'|translate:{day:exactExpireDays} }}
                  </span>
                  <ng-template #reloginRecommended>
                    <b class="text-warning">{{'admin.exact.relogin_recommended'|translate}}</b>
                  </ng-template>
                </a>
            </li>
            <li *ngIf="auth.isLoggedIn() && (auth.isDealerAdmin()|| auth.isDealerModerator() || auth.isDealerUser())">
              <div class="bg-light text-dark  pe-2 ps-2 point-box">
                <div *ngIf="!isRequestedForUpdatePoints else waitForPointResponse" (click)="requestUpdatePoints()">
                  {{auth.getCompanyName()}} <span *ngIf="auth.isDealerPointEnabled()"> (<strong>{{auth.getDealerPoints()}}</strong> {{'admin.order.points'|translate}}) </span>
                </div>
              </div>
              <ng-template #waitForPointResponse>{{ 'admin.dealer.dashboard.wait_for_updating_points' | translate }}</ng-template>
            </li>
            <li (clickOutside)="notificationOutsideClick('profile')" class="user-profile header-notification ripple light" (click)="toggleProfileNotification()">
              <a href="javascript:">
                <span>{{auth.getFullName()}}</span>
                <i class="feather icon-chevron-down"></i>
              </a>
              <ul [@notificationBottom]="profileNotification" class="show-notification profile-notification" [ngClass]="profileNotificationClass">
                <!--<li class="ripple">-->
                <!--<a href="javascript:">-->
                <!--<i class="feather icon-settings"></i> Settings-->
                <!--</a>-->
                <!--</li>-->
                <!--<li class="ripple">-->
                <!--<a [routerLink]="['/user/profile/']">-->
                <!--<i class="feather icon-user"></i> Profile-->
                <!--</a>-->
                <!--</li>-->
                <!--<li class="ripple">-->
                <!--<a href="javascript:">-->
                <!--<i class="feather icon-mail"></i> My Messages-->
                <!--</a>-->
                <!--</li>-->
                <!--<li class="ripple">-->
                <!--<a [routerLink]="['/auth/lock-screen/']" target="_blank">-->
                <!--<i class="feather icon-lock"></i> Lock Screen-->
                <!--</a>-->
                <!--</li>-->
                <li class="ripple" style="padding: 0">
                  <a (click)="lock()" style="display:block;width:100%;height:100%;padding: 15px;">
                    <i class="feather icon-lock"></i> {{'admin.lock'|translate}}
                  </a>
                </li>
                <li class="ripple" style="padding: 0">
                  <a (click)="logout()" style="display:block;width:100%;height:100%;padding: 15px;">
                    <i class="feather icon-log-out"></i> {{'admin.logout'|translate}}
                  </a>
                </li>
              </ul>
            </li>

          </ul>
        </div>
      </div>
    </nav>


    <div class="pcoded-main-container" [style.margin-top]="headerFixedMargin"> <!--  -->
      <div class="pcoded-wrapper">
        <nav
          *ngIf="!auth.isDealerTabletUser()"
          id="main_navbar"
          class="pcoded-navbar"
          (clickOutside)="onClickedOutsideSidebar($event)"
          [exclude]="'#mobile-collapse'"
          [attr.navbar-theme]="navBarTheme"
          [attr.active-item-theme]="activeItemTheme"
          sub-item-theme="theme2"
          active-item-style="style0"
          [attr.pcoded-header-position]="pcodedHeaderPosition"
          [attr.pcoded-navbar-position]="pcodedSidebarPosition"
          [style.top]="headerFixedTop"
          [style.height]="sidebarFixedNavHeight"
          (mouseleave)="hoverOutsideSidebar()"
        >
          <div class="custom-scrollbar" 
               [style.max-width]="'235px'" 
               [style.max-height]="sidebarFixedHeight" 
               [ngClass]="perfectDisable">
            <div class="pcoded-inner-navbar main-menu" appAccordion>
              <div class="">
                <div class="main-menu-header pb-0">
                </div>
                <!--<div class="main-menu-content">-->
                <!--<ul>-->
                <!--<li [@mobileMenuTop]="isCollapsedSideBar" class="more-details" [ngClass]="isCollapsedSideBar">-->
                <!--<a [routerLink]="['/user/profile']" class="ripple"><i class="feather icon-user"></i>View Profile</a>-->
                <!--<a href="javascript:" class="ripple"><i class="feather icon-settings"></i>Settings</a>-->
                <!--<a (click)="logout()" class="ripple" ><i class="feather icon-log-out"></i>Logout</a>-->
                <!--</li>-->
                <!--</ul>-->
                <!--</div>-->
              </div>

              <div *ngFor="let asideItems of asideMenuItems" class="d-color">
                <!--<div class="pcoded-navigation-label" [attr.menu-title-theme]="menuTitleTheme">{{asideItems.label}}</div>-->
                <ul class="pcoded-item pcoded-left-item" [attr.item-border]="itemBorder" [attr.item-border-style]="itemBorderStyle" [attr.subitem-border]="subItemBorder" *ngFor="let asideItem of asideItems.main" appAccordionLink group="{{asideItem.name}}">
                  <li [routerLinkActive]="['active']" *ngIf="asideItem.type === 'external'" appAccordionLink group="{{asideItem.name}}">
                    <a [routerLinkActive]="['active']" class="ripple" href="{{asideItem.external}}" target="{{asideItem.target ? '_blank' : '_self'}}" appAccordionToggle>
                      <span class="pcoded-micon"><i class="{{ asideItem.icon }}"></i><b>{{ asideItem.short_label }}</b></span>
                      <span class="pcoded-mtext">{{ asideItem.name|translate }}</span>
                      <span *ngFor="let asideBadge of asideItem.badge" class="pcoded-badge label label-{{ asideBadge.type }}">
                        <i *ngIf="asideBadge.icon" class="{{asideBadge.icon}}"></i>
                        {{asideBadge.value}}</span>
                      <span class="pcoded-mcaret"></span>
                    </a>
                  </li>

                  <li [routerLinkActive]="['active']" *ngIf="asideItem.type === 'link' && !menuItems.isDisable(asideItem.name)" appAccordionLink group="{{asideItem.name}}">
                    <a [routerLinkActive]="['active']" class="ripple" [routerLink]="asideItem.route" target="{{asideItem.target ? '_blank' : '_self'}}" appAccordionToggle>
                      <span class="pcoded-micon"><i class="{{ asideItem.icon }}"></i><b>{{ asideItem.short_label }}</b></span>
                      <span class="pcoded-mtext">{{ asideItem.name|translate }}</span>
                      <span *ngFor="let asideBadge of asideItem.badge" class="pcoded-badge label label-{{ asideBadge.type }}">
                        <i *ngIf="asideBadge.icon" class="{{asideBadge.icon}}"></i>
                        {{asideBadge.value}}</span>
                      <span class="pcoded-mcaret"></span>
                    </a>
                    <ng-template #mainContent>
                      <a [routerLinkActive]="['active']" class="ripple" [routerLink]="asideItem.route" target="{{asideItem.target ? '_blank' : '_self'}}" appAccordionToggle>
                        <span class="pcoded-micon"><i class="{{ asideItem.icon }}"></i><b>{{ asideItem.short_label }}</b></span>
                        <span class="pcoded-mtext">{{ asideItem.name|translate }}</span>
                        <span *ngFor="let asideBadge of asideItem.badge" class="pcoded-badge label label-{{ asideBadge.type }}">
                          <i *ngIf="asideBadge.icon" class="{{asideBadge.icon}}"></i>
                          {{asideBadge.value}}
                        </span>
                        <span class="pcoded-mcaret"></span>
                      </a>
                    </ng-template>
                  </li>
                  <li (mouseleave)="fireClickLeave($event)" [routerLinkActive]="['active']" *ngIf="asideItem.type === 'sub'" class="pcoded-hasmenu" [attr.dropdown-icon]="dropDownIcon" [attr.subitem-icon]="subItemIcon" appAccordionLink group="{{asideItem.name}}">
                    <a (mouseover)="fireClick($event)" [routerLinkActive]="['active']" href="javascript:;" appAccordionToggle>
                      <div class="ripple menu-ripple"></div>
                      <span class="pcoded-micon"><i class="{{ asideItem.icon }}"></i><b>{{ asideItem.short_label }}</b></span>
                      <span class="pcoded-mtext">{{ asideItem.name|translate }}</span>
                      <span *ngFor="let asideBadge of asideItem.badge" class="pcoded-badge label label-{{ asideBadge.type }}">
                        <i *ngIf="asideBadge.icon" class="{{asideBadge.icon}}"></i>
                        {{asideBadge.value}}
                      </span>
                      <span class="pcoded-mcaret"></span>
                    </a>
                    <ul class="pcoded-submenu">
                      <ng-template ngFor let-asideChildren [ngForOf]="asideItem.children">
                        <li [routerLinkActive]="['active']" *ngIf="asideChildren.type !== 'sub'">
                          <a [routerLinkActive]="['active']" [routerLink]="asideChildren.route" target="{{asideChildren.target ? '_blank' : '_self'}}">
                            <div class="ripple menu-ripple"></div>
                            <span class="pcoded-micon"><i class="icon-angle-right"></i></span>
                            <span class="pcoded-mtext">{{ asideChildren.name|translate }} </span>
                            <span *ngFor="let asideChildrenBadge of asideChildren.badge" class="pcoded-badge label label-{{ asideChildrenBadge.type }}">{{asideChildrenBadge.value}}</span>
                            <span class="pcoded-mcaret"></span>
                          </a>
                        </li>

                        <li (mouseleave)="fireClickLeave($event)" [routerLinkActive]="['active']" class="pcoded-hasmenu" [attr.dropdown-icon]="dropDownIcon" [attr.subitem-icon]="subItemIcon" *ngIf="asideChildren.type === 'sub'" appAccordionLink group="sub-toggled">
                          <a (mouseover)="fireClick($event)" [routerLinkActive]="['active']" href="javascript:;" appAccordionToggle>
                            <div class="ripple menu-ripple"></div>
                            <span class="pcoded-micon"><i class="icon-direction-alt"></i></span>
                            <span class="pcoded-mtext">{{ asideChildren.name|translate }}</span>
                            <span *ngFor="let asideChildrenBadge of asideChildren.badge" class="pcoded-badge label label-{{ asideChildrenBadge.type }}">{{asideChildrenBadge.value}}</span>
                            <span class="pcoded-mcaret"></span>
                          </a>
                          <ul class="pcoded-submenu">
                            <ng-template ngFor let-asideChildrenSub [ngForOf]="asideChildren.children">
                              <li [routerLinkActive]="['active']">
                                <a [routerLinkActive]="['active']" [routerLink]="asideChildrenSub.route" target="{{asideChildrenSub.target ? '_blank' : '_self'}}">
                                  <div class="ripple menu-ripple"></div>
                                  <span class="pcoded-micon"><i class="icon-angle-right"></i></span>
                                  <span class="pcoded-mtext">{{ asideChildrenSub.name|translate }}</span>
                                  <span *ngFor="let asideChildrenSubBadge of asideChildrenSub.badge" class="pcoded-badge label label-{{ asideChildrenSubBadge.type }}">{{asideChildrenSubBadge.value}}</span>
                                  <span class="pcoded-mcaret"></span>
                                </a>
                              </li>
                            </ng-template>
                          </ul>
                        </li>
                      </ng-template>
                    </ul>
                  </li>
                </ul>
              </div>
              <!--<div class="text-center"> v7.3 </div>-->
            </div>
          </div>
        </nav>
        <div class="pcoded-content" [ngClass]="{'no-margin': auth.isDealerTabletUser()}">
          <app-breadcrumbs></app-breadcrumbs>
          <div class="pcoded-inner-content">
            <!-- Main-body start -->
            <div class="main-body">
              <div class="page-wrapper">
                <router-outlet>
                  <title></title>
                  <app-spinner></app-spinner>
                </router-outlet>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- redirect url -->
<app-modal-basic hideHeader="true" hideFooter="true" hideBackground="true" modalClass="login-modal" [zIndex]="1050" #lockModal>
  <div class="app-modal-body">
    <app-login-modal (afterLogin)="lockModal.hide()"></app-login-modal>
  </div>
</app-modal-basic>

<app-modal-basic #confirmActionModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{'global.warning' | translate}}</h4>
    <button type="button" class="close basic-close" (click)="confirmActionModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'admin.exact.re-login-warning' | translate}}</p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="confirmActionModal.hide()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light"
            (click)="connectToExact()">{{'global.continue'|translate}}</button>
  </div>
</app-modal-basic>
